import { DEFAULT_LANGUAGE } from 'constants/LanguageConstants';
import { getPersistedData } from 'services/StateLoader';

/** Older browsers expose the user locale as the non-standard `navigator.userLanguage`. */
type LegacyNavigator = Navigator & { userLanguage?: string };

const OVERRIDEN_LANGUAGES: Record<string, string> = {
  en: 'en_us',
  nb: 'no',
  nn: 'no',
};

// Define user's language. Different browsers have the user locale defined
// on different fields on the `navigator` object, so we make sure to account
// for these different by checking all of them
const browserLocale =
  navigator?.languages?.[0] ||
  navigator.language ||
  (navigator as LegacyNavigator).userLanguage ||
  DEFAULT_LANGUAGE;
const locale = browserLocale.split('-')[0];

export const getDefaultLocale = (): string => {
  const defaultLocale: string = getPersistedData()?.locale ?? locale ?? DEFAULT_LANGUAGE;
  return OVERRIDEN_LANGUAGES[defaultLocale] ?? defaultLocale;
};
